import * as types from './types';

export const reducer = (state, action) => {
  switch (action.type) {
    case types.OPEN_MENU: {
      return { ...state, menuOpen: true };
    }
    case types.CLOSE_MENU: {
      return {
        ...state,
        menuOpen: false,
      };
    }
  }

  return { ...state };
};
